const GENERIC_PORTAL_TITLES = new Set(['portal conversation', 'opened record']);

const normalizeEmail = value => String(value || '').trim().toLowerCase();
const camelize = value =>
  value.replace(/_([a-z])/g, (_, character) => character.toUpperCase());

const valueFor = (attributes, customAttributes, key) => {
  const camelKey = camelize(key);
  return (
    customAttributes[key] ||
    customAttributes[camelKey] ||
    attributes[key] ||
    attributes[camelKey]
  );
};

export const getPortalThread = conversation => {
  const attributes =
    conversation?.additional_attributes || conversation?.additionalAttributes || {};
  const customAttributes =
    conversation?.custom_attributes || conversation?.customAttributes || {};
  if (valueFor(attributes, customAttributes, 'tnm_source') !== 'firestore') {
    return null;
  }

  const contextValue = key =>
    String(valueFor(attributes, customAttributes, key) || '').trim();
  const rawParticipants =
    valueFor(attributes, customAttributes, 'tnm_portal_recipient_roster') ||
    valueFor(attributes, customAttributes, 'tnm_portal_participants') ||
    [];
  const participantByEmail = new Map();

  if (Array.isArray(rawParticipants)) {
    rawParticipants.forEach(person => {
      const email = normalizeEmail(person?.email);
      if (!email || participantByEmail.has(email)) return;
      participantByEmail.set(email, {
        email,
        name: String(person?.name || person?.email || '').trim(),
      });
    });
  }

  const configuredRecipients = valueFor(
    attributes,
    customAttributes,
    'tnm_portal_recipient_emails'
  );
  const configuredEmails = Array.isArray(configuredRecipients)
    ? configuredRecipients
        .map(normalizeEmail)
        .filter(email => participantByEmail.has(email))
    : [];
  const recipientEmails = configuredEmails.length
    ? [...new Set(configuredEmails)]
    : [...participantByEmail.keys()];

  const routeLabel = {
    shows: 'Show',
    campaigns: 'Campaign',
    inquiries: 'Inquiry',
    reads: 'Ad read',
  }[valueFor(attributes, customAttributes, 'tnm_portal_route')];
  const recordTitle = String(
    valueFor(attributes, customAttributes, 'tnm_portal_title') || ''
  ).trim();
  const context = [
    contextValue('tnm_portal_advertiser'),
    contextValue('tnm_portal_show'),
  ].filter((value, index, values) => {
    const normalized = value.toLocaleLowerCase();
    return (
      normalized &&
      values.findIndex(item => item.toLocaleLowerCase() === normalized) === index
    );
  });
  const usefulRecordTitle = !GENERIC_PORTAL_TITLES.has(
    recordTitle.toLocaleLowerCase()
  );

  return {
    title: context.length
      ? [...context, routeLabel].filter(Boolean).join(' · ')
      : [routeLabel, usefulRecordTitle ? recordTitle : 'Portal thread']
          .filter(Boolean)
          .join(' · '),
    participants: recipientEmails.map(email => participantByEmail.get(email)),
  };
};
